export { Icon as BaseIcon } from "../styles/BaseIcon";
